import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./Index.css";

const AnnouncementItem = ({ title, date, content, onClick }) => {
  return (
    <div className="announcement-item">
      <div
        className="announcement-title"
        style={{ cursor: "pointer" }}
        onClick={onClick}
      >
        {title}
      </div>
      <p
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          margin: 0,
        }}
        title={content}
      >
        {content}
      </p>
      <div className="announcement-date">
        <span className="calendar-icon">📅</span>
        <span>{date}</span>
      </div>
    </div>
  );
};

export default function Announcement(props) {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  return (
    <div className="announcement-card">
      {/* Header */}
      <div className="announcement-header">
        <h3>{props.title}</h3>
        <button className="refresh-btn" onClick={props.handleRefresh}>
          🔄
        </button>
      </div>

      {/* List */}
      <div className="announcement-list">
        {props.announcements.length === 0 ? (
          <div className="announcement-empty">
            {t.noRecordsToDisplay || "No records to display"}
          </div>
        ) : (
          props.announcements.map((item, index) => (
            <React.Fragment key={item.id}>
              <AnnouncementItem
                title={item.subject}
                content={item.content}
                date={formatDate(item.date)}
                onClick={() => props.hanldeNavigate(item)}
              />
              {index < props.announcements.length - 1 && (
                <hr className="announcement-divider" />
              )}
            </React.Fragment>
          ))
        )}
      </div>

      {/* Footer */}
      <hr className="announcement-divider" />
      <div className="announcement-footer">
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            props.handleAllAnnouncement();
          }}
        >
          {t.seeAll || "See All"} {props.allDetails}
        </Link>
      </div>
    </div>
  );
}
